import { useState, useEffect } from 'react';
import { GetApplicationManagementByID } from '../../_api';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import Section from '../../components/NewApplication/Section';
import ExtensionTypeCreate from './components/ExtensionTypeForms/ExtensionTypeCreate';
import ExtensionTypesTable from './components/ExtensionTypesTable';
const ExtensionManagement = ({
	appID,
	currentUser,
	requirementNumber,
	readOnly,
}) => {
	const [app, setApp] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	//on load, retrieve the AppManagementModel for the selected app
	useEffect(() => {
		GetApplicationManagementByID(appID)
			.then(response => {
				setApp(response);
			})
			.then(x => setIsLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const reloadExtension = () => {
		setIsLoading(true);
		GetApplicationManagementByID(appID)
			.then(response => {
				setApp(response);
			})
			.then(x => setIsLoading(false));
	};

	return (
		<>
			<>
				<Section label='Manage Extensions'>
					{isLoading ? (
						<Spinner />
					) : (
						<>
							<ExtensionTypesTable
								app={app}
								requirementNumber={requirementNumber}
								currentUser={currentUser}
								readOnly={readOnly}
								reload={reloadExtension}
							/>
							<ExtensionTypeCreate
								app={app}
								currentUser={currentUser}
								reload={reloadExtension}
								disabled={readOnly}
								requirementNumber={requirementNumber}
							/>
						</>
					)}
				</Section>
			</>
		</>
	);
};

export default ExtensionManagement;
